import React, { FC } from 'react';
import Loader from 'react-loader-spinner';
import { Grid } from '@material-ui/core';

import { useStyles } from './styles';
import Colors from '../../assets/Colors';

const defaultSize = 100;

interface LoaderComponentProps {
    fullPage?: boolean;
    size?: number;
}

const LoaderComponent: FC<LoaderComponentProps> = ({ fullPage, size }) => {
    const classes = useStyles();

    if (fullPage) {
        return (
            <Grid container xs={12} justify="center" alignContent="center" className={classes.fullPage}>
                <Loader
                    // @ts-ignore
                    type="Puff"
                    color={Colors.main.primary}
                    height={size || defaultSize}
                    width={size || defaultSize}
                />
            </Grid>
        );
    }

    return (
        <Loader
            // @ts-ignore
            type="Puff"
            color={Colors.main.primary}
            height={size || defaultSize}
            width={size || defaultSize}
        />
    );
};

export default LoaderComponent;
